import * as React from "react";
import { useSelector } from "react-redux";

function ExtendValidityIcon({ width = 19, height = 19, ...props }) {
  const { isDarkTheme } = useSelector(({ common }) => common);
  return (
    <span className="anticon iiht-sidebar-icons ant-menu-item-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={16.804}
        height={16.804}
        {...props}
        viewBox="0 0 21 21"
      >
        <path
          fill={isDarkTheme ? "#3c4252" : "#62BAB3"}
          stroke={isDarkTheme ? "#62BAB3" : "#3c4252"}
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M15.5 9.5V5.522l-4-.022m-2 10.023h-4V11.5"
        />
      </svg>
    </span>
  );
}

export default ExtendValidityIcon;
